/**
 * color-gallery-bridge.js
 * Upload to Assets folder in your Dawn theme.
 */

(function () {

  function filterGalleryByColor(colorValue) {
    if (!colorValue) return;
    const color = colorValue.toLowerCase().trim();

    const viewer = document.querySelector('[id^="GalleryViewer"]');
    const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer) return;

    // --- Main viewer slides ---
    let lastColor = null;
    [...viewer.querySelectorAll('[data-media-id]')].forEach(slide => {
      const img = slide.querySelector('img');
      const alt = (img?.alt || '').toLowerCase().trim();

      if (alt !== '') {
        lastColor = alt;
        slide.style.display = alt === color ? '' : 'none';
      } else {
        // Empty-alt duplicate — inherit from last real slide
        slide.style.display = lastColor === color ? '' : 'none';
      }
    });

    // --- Thumbnails ---
    if (thumbnails) {
      let lastThumbColor = null;
      [...thumbnails.querySelectorAll('[data-target]')].forEach(thumb => {
        const img = thumb.querySelector('img');
        const alt = (img?.alt || '').toLowerCase().trim();

        if (alt !== '') {
          lastThumbColor = alt;
          thumb.style.display = alt === color ? '' : 'none';
        } else {
          thumb.style.display = lastThumbColor === color ? '' : 'none';
        }
      });
    }

    // --- Scroll back to first visible slide ---
    const firstVisible = viewer.querySelector('[data-media-id]:not([style*="display: none"])');
    if (firstVisible) {
      const slider = viewer.querySelector('.slider') || viewer;
      slider.scrollTo({ left: 0, behavior: 'instant' });
      viewer.querySelectorAll('[data-media-id]').forEach(s => s.classList.remove('is-active'));
      firstVisible.classList.add('is-active');

      if (thumbnails) {
        const firstVisibleId = firstVisible.dataset.mediaId;
        thumbnails.querySelectorAll('button').forEach(b => b.removeAttribute('aria-current'));
        const firstThumb = thumbnails.querySelector(`[data-target="${firstVisibleId}"] button`);
        if (firstThumb) firstThumb.setAttribute('aria-current', 'true');
        const thumbSlider = thumbnails.querySelector('.slider') || thumbnails;
        thumbSlider.scrollTo({ left: 0, behavior: 'instant' });
      }
    }
  }

  function getColorFieldset() {
    for (let fs of document.querySelectorAll('fieldset')) {
      const legend = fs.querySelector('legend');
      if (legend && (legend.textContent.toLowerCase().includes('color') || legend.textContent.toLowerCase().includes('colour'))) {
        return fs;
      }
    }
    return null;
  }

  function init() {
    // Listen to color swatch clicks
    document.addEventListener('change', function (e) {
      const input = e.target;
      if (!input.matches('input[type="radio"], select')) return;
      const fieldset = input.closest('fieldset');
      if (!fieldset) return;
      const legend = fieldset.querySelector('legend');
      if (!legend) return;
      const legendText = legend.textContent.toLowerCase();
      if (!legendText.includes('color') && !legendText.includes('colour')) return;
      filterGalleryByColor(input.value);
    });

    // Filter on page load to match default selected color
    setTimeout(function () {
      const colorFieldset = getColorFieldset();
      if (!colorFieldset) return;
      const checked = colorFieldset.querySelector('input:checked') || colorFieldset.querySelector('input');
      if (checked) filterGalleryByColor(checked.value);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();